
/**
* @author Camilo
* @since  14/12/2017
**/
export class OpcionSistemaModel{

	constructor(public nidcomando:number, public vtitulo:string, public ncrear:boolean, public neditar:boolean, public neliminar:boolean, public nconsultar:boolean, public cdescriprol:string, public bloquear:boolean, public ntipoempresa:number, public ntodosloscontratos:number){}
	

}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/AdministracionUsuarios/Opcion.model.ts